<template>
  <DefaultLayout>
    <template slot="center">
      <div class="white-card" style="min-height: 100px">
        <div class="loader absolute" v-if="loading"></div>
        <question :show-more="false" v-if="question" :question="question"></question>
      </div>
      <template v-if="!loading && responses.length">
        <h3 class="mt-4 mb-1">Réponses</h3>
        <div class="white-card mb-3" v-if="responses" v-for="(q,i) in responses" :key="i">
          <question :question="q"></question>
        </div>
      </template>
    </template>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/Layout/DefaultLayout";
import Question from "@/components/Questions/Question";

export default {
  name: "QuestionView",
  data() {
    return {
      question: null,
      responses: null,
      loading: false
    }
  },
  components: {Question, DefaultLayout},
  methods: {
    load() {
      const id = this.$route.params.id
      this.loading = true
      this.$axios.get('/question/' + id)
        .then(({data}) => {
          this.question = data.question
          this.responses = data.responses
        })
        .finally(() => this.loading = false)
    }
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>

</style>
